.next {
  display: flex;
  position: relative;
  margin-right: 0.8rem;
  justify-content: center;
  align-items: center;
  width: 1.6rem;
  height: 1.6rem;
  transition: all 0.3s ease;
  border-radius: 0.4rem;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  outline: none;
  background-color: transparent;

  & > div {
    z-index: 10;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &::after {
    content: '';
    position: absolute;
    display: none;
    border-radius: var(--border-radius-small);
    background-color: var(--color-grayscale-tuna);
    border: 1px solid var(--color-grayscale-trout);
    height: calc(100% + 0.4rem);
    width: calc(100% + 0.4rem);
  }

  &[data-is-open='true']::after {
    display: block;
  }
}
